import { DeviceType } from '@/api/client'
import type { RouteRecordRaw } from 'vue-router'
import { deviceType, layout, page } from './utils'
import { areas } from '../areas'
import { useAppStateStore } from '@/stores/AppStateStore'
import { BarBackgroundStyle } from '@/composables/useNativeStyle'

export const sharedRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: layout('PageLayout'),
    children: deviceType(
      [DeviceType.PERSONAL, DeviceType.TEAM, DeviceType.TERMINAL],
      [
        {
          path: '/app-settings',
          name: 'appSettings',
          meta: {
            showHeader: false,
          },
          component: page('settings-and-legal/AppSettingsPage'),
        },
        {
          path: '/legal-notes',
          name: 'legalNotes',
          meta: {
            showHeader: false,
          },
          component: page('settings-and-legal/LegalNotesPage'),
        },
        {
          path: '/imprint',
          name: 'imprint',
          meta: {
            showHeader: false,
          },
          component: page('settings-and-legal/ImprintPage'),
        },
        {
          path: '/licenses',
          name: 'licensePage',
          meta: {
            showHeader: false,
          },
          component: page('settings-and-legal/LicensePage'),
        },
      ],
    ),
  },
]

export const onboardingRoutes = deviceType(
  [DeviceType.PERSONAL, DeviceType.TEAM, DeviceType.TERMINAL],
  [
    {
      path: '/onboarding/personal-app',
      name: 'personalAppOnboarding',
      component: page('onboarding/PersonalAppOnboardingPage'),
      meta: {
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      },
    },
    {
      path: '/onboarding/team-app',
      name: 'teamAppOnboarding',
      component: page('onboarding/TeamAppOnboardingPage'),
      meta: {
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      },
    },
    {
      path: '/onboarding/my-area',
      name: 'myAreaOnboarding',
      component: page('onboarding/MyAreaOnboardingPage'),
      meta: {
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        area: areas.MY_AREA,
      },
      beforeEnter: (_to, _from, next) => {
        useAppStateStore().isLoading = true
        setTimeout(() => {
          useAppStateStore().isLoading = false
        }, 10000)
        next()
      },
    },
  ],
)
